module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-frown-02f5f167.svg";